import { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import Button from '@material-ui/core/Button';
import { loginRequest } from "../authConfig";
import { LanguageContext } from "../Helpers/Context";

export const SignInButton = () => {
    const { instance } = useMsal();
    const { dictionary } = useContext(LanguageContext);

    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch(e => {
            console.log(e);
        });
    }
    return (
        <Button variant="outlined" size="small" color="inherit" onClick={() => handleLogin()}>{dictionary.signIn}</Button>
    )
}